module.exports = __webpack_public_path__ + "static/img/video_icon1.71bb80d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon1.png
// module id = ZTL1
// module chunks = 0